module.exports = __webpack_public_path__ + "img/027.bbfa2632.jpg";